import * as React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { StackLayout, HeadingText } from '@leagueplatform/genesis-core';
import { HealthMetricAverageValue } from '@leagueplatform/dashboard-api';
import { shapes } from '#components/charts/core/xychart/primitives/Shape.tsx';
import { getHealthMetricUnitDisplayValue } from '#utils/get-health-metric-unit-display-value.ts';
import { getValueUnitDisplayLabel } from '#utils/get-value-unit-display-label.ts';
import { DatumLegend, DatumValueWithUnit } from './datum-legend';

type AverageValuePanelProps = {
  averages: HealthMetricAverageValue[];
};

export function AverageValuePanel({ averages }: AverageValuePanelProps) {
  const { formatMessage } = useIntl();
  return (
    <StackLayout
      orientation="horizontal"
      horizontalAlignment="center"
      spacing="$three"
    >
      {averages
        .sort((a, b) => (a.config.data.order < b.config.data.order ? -1 : 1))
        .map((average) => {
          const shape = shapes[average.config.data.order];
          const unit = getHealthMetricUnitDisplayValue(
            average.value,
            average.config.data.unit,
          );
          return (
            <StackLayout horizontalAlignment="center" key={average.id}>
              {averages.length > 1 ? (
                <DatumLegend
                  shape={shape}
                  name={average.config.data.name.toUpperCase()}
                  value={average.value}
                  unit={unit}
                />
              ) : (
                <>
                  <HeadingText level="4" size="md" emphasis="subtle">
                    {formatMessage({
                      id: 'AVERAGE',
                    }).toUpperCase()}
                  </HeadingText>
                  <StackLayout orientation="horizontal" spacing="$half">
                    {getValueUnitDisplayLabel({
                      value: average.value,
                      unitOptions: average.config.data.unit,
                    }).map(([displayValue, displayUnit]) => (
                      <DatumValueWithUnit
                        value={displayValue}
                        unit={displayUnit}
                      />
                    ))}
                  </StackLayout>
                </>
              )}
            </StackLayout>
          );
        })}
    </StackLayout>
  );
}
